import "./fleetHistoryTimeRangeSelector.component.scss";

import * as angular from "angular";
import * as moment from "moment";
import { VeriDate } from "@services/veriDate.service";

export interface ITimeRangeActivityBar {
    hour: number;
    total: number;
    maxTotal: number;
    percentage: number;
}

interface IComponentBindings {
    timeRangeActivityBars: ITimeRangeActivityBar[];
    selectedFromMinuteOfDay: number;
    selectedToMinuteOfDay: number;
}

class FleetHistoryTimeRangeSelectorController implements angular.IComponentController, IComponentBindings {

    // bindings
    timeRangeActivityBars: ITimeRangeActivityBar[];
    selectedFromMinuteOfDay: number;
    selectedToMinuteOfDay: number;

    // --------------------------------
    totalMinutesInRange: number = 1439;
    timeIsSquished: boolean = false;

    selectedEarliestPercentage: number;
    selectedLatestPercentage: number;
    selectedEarliestMoment: moment.Moment;
    selectedLatestMoment: moment.Moment;

    static $inject = ["veriDate"];

    constructor(private readonly veriDate: VeriDate) {}

    $onInit(): void {
        this.render();
    }

    $onChanges(onChangesObj: angular.IOnChangesObject): void {
        if (onChangesObj["selectedFromMinuteOfDay"] || onChangesObj["selectedToMinuteOfDay"]) {
            this.render();
        }
    }

    private render(): void {
        this.selectedEarliestPercentage = parseFloat(((this.selectedFromMinuteOfDay / this.totalMinutesInRange) * 100).toFixed(2));
        this.selectedLatestPercentage = parseFloat((100 - ((this.selectedToMinuteOfDay / this.totalMinutesInRange) * 100)).toFixed(2));

        this.selectedEarliestMoment = this.veriDate.createMoment(new Date()).set({ hour: 0, minute: this.selectedFromMinuteOfDay });
        this.selectedLatestMoment = this.veriDate.createMoment(new Date()).set({ hour: 0, minute: this.selectedToMinuteOfDay });

        this.timeIsSquished = (Math.abs(this.selectedFromMinuteOfDay - this.selectedToMinuteOfDay) < 200); // move to being relative rather than fixed at 200
    }
}

export class FleetHistoryTimeRangeSelectorComponent implements angular.IComponentOptions {
    bindings: any;
    controller: any;
    template: string;

    constructor() {
        this.bindings = {
            timeRangeActivityBars: "<",
            selectedFromMinuteOfDay: "<",
            selectedToMinuteOfDay: "<"
        };

        this.controller = FleetHistoryTimeRangeSelectorController;
        this.template = require("./fleetHistoryTimeRangeSelector.component.html");
    }
}
